import { DataProvider } from '@repo/ui/dataProvider'
import { useEffect } from 'react'

import { Demo } from '@/components/Demo'
import { ErrorRoute } from '@/routes/ErrorRoute'
import { LoadingRoute } from '@/routes/LoadingRoute'
import { RootState } from '@/store'
import { demoStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'

export function DemoRoute() {
  const dispatch = useStoreDispatch()
  useEffect(() => {
    void dispatch(demoStoreActions.initDemo())
  }, [])
  return (
    <DataProvider
      errorComponent={<ErrorRoute />}
      loadingComponent={<LoadingRoute />}
      selectors={[(state: RootState) => state.demo.organizations]}
      render={(organizations) => <Demo organizations={organizations} />}
    />
  )
}
